import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import ProductCard from './ProductCard';
import ProductService from '../../../services/ProductService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  ProductCard: {
    height: '100%'
  }
}));

const ProductList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [products, setProducts] = useState([]);

  const foo = async () => {
    const fetchData = typeof id !== 'undefined'
      ? await ProductService.getById(id)
      : await ProductService.getAll();

    if (fetchData?.code === 200) {
      if (id) {
        setProducts([fetchData.data]);
      } else {
        setProducts(fetchData.data);
      }
    }
  };

  useEffect(() => {
    foo();
  }, []);

  useEffect(() => {
    if (id && id?.length > 0) {
      foo();
    }
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Imágenes de productos"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {products.map((product) => (
              <Grid
                item
                key={product.id}
                lg={4}
                md={6}
                xs={12}
              >
                <ProductCard
                  onSuccess={foo}
                  className={classes.ProductCard}
                  product={product}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default ProductList;
